<header class="app-header">
  <!-- Sidebar collapse toggle — sits at the header's left edge, visually right of
       the sidebar brand. -->
  <button
    type="button"
    class="sidebar-toggle"
    (click)="onToggleSidebar()"
    [attr.aria-expanded]="!sidebarCollapsed()"
    [attr.aria-label]="sidebarCollapsed() ? 'Expand sidebar menu' : 'Collapse sidebar menu'"
  >
    <i class="bi bi-list" aria-hidden="true"></i>
  </button>

  <div class="header-actions ms-auto">
    <!-- Quick Start Guide toggle -->
    <button
      type="button"
      class="quick-start-toggle"
      [class.is-open]="quickStartOpen()"
      (click)="onToggleQuickStart()"
      [attr.aria-label]="quickStartOpen() ? 'Close quick start guide' : 'Open quick start guide'"
    >
      <i class="bi bi-rocket-takeoff" aria-hidden="true"></i>
      @if (quickStartPending()) {
        <span class="quick-start-badge" aria-hidden="true"></span>
      }
    </button>

    <!-- Username (display only, not clickable) -->
    <span class="header-username">{{ username }}</span>

    <!-- User dropdown toggle (separate from username) -->
    <div class="dropdown">
      <button class="dropdown-toggle-btn" type="button" data-bs-toggle="dropdown"
              aria-expanded="false" aria-label="User menu">
        <i class="bi bi-chevron-down"></i>
      </button>
      <ul class="dropdown-menu dropdown-menu-end shadow-sm">
        <li>
          <a class="dropdown-item" href="javascript:void(0)" (click)="openEditAccount()">
            <i class="bi bi-person-gear me-2"></i>Edit Account
          </a>
        </li>
        <li><hr class="dropdown-divider"></li>
        <li>
          <h6 class="dropdown-header">Theme: {{ activeTheme().label }}</h6>
        </li>
        @for (theme of availableThemes(); track theme.id) {
          <li>
            <a class="dropdown-item" href="javascript:void(0)" (click)="changeTheme(theme)">
              <i class="bi bi-palette me-2"></i>{{ theme.label }}
            </a>
          </li>
        }
      </ul>
    </div>
  </div>
</header>
